import React from 'react';
import '../css/admin/css/style.css';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class NotFound extends React.Component {
	render() {
		return (
			<div className="error m-b-10 error-code" style={{ marginTop: '175px', position: 'relative', justifyContent: 'space-around' }}>
				<div>

					<i className="fa fa-warning" />
					<div className="flex-center">
						<CircularProgress />
					</div>
				</div>

			</div>
		);
	}
}
